import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

function RWGPSSuccess() {
    const navigate = useNavigate();
    const rwgpsAuth = useSelector((state) => state.auth.connections.rwgps);
    const [isLoading,] = useState(true);

    useEffect(() => {
        // If RWGPS auth is present, redirect to home
        if (rwgpsAuth) {
            navigate('/', { replace: true });
        }
    }, [rwgpsAuth, navigate]);

    // Show loading state while waiting for RWGPS auth
    if (isLoading) {
        return (
            <Container maxWidth="sm">
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 'calc(100vh - 64px)',
                    textAlign: 'center',
                    py: 4
                }}>
                    <CircularProgress size={60} sx={{ mb: 3 }} />
                    <Typography variant="h5" gutterBottom>
                        Connecting to Ride With GPS
                    </Typography>
                    <Typography color="text.secondary">
                        Please wait while we complete your authentication...
                    </Typography>
                </Box>
            </Container>
        );
    }

    // Fallback error state if something goes wrong
    return (
        <Container maxWidth="sm">
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'calc(100vh - 64px)',
                textAlign: 'center',
                py: 4
            }}>
                <Typography variant="h5" gutterBottom color="error">
                    Authentication Failed
                </Typography>
                <Typography color="text.secondary" paragraph>
                    There was an error connecting to Ride With GPS. Please try again.
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="/thirdparty"
                    sx={{ mt: 2 }}
                >
                    Try Again
                </Button>
            </Box>
        </Container>
    );
}

export default RWGPSSuccess;